<template>
    <card class="card-multiple-actu u-align--left u-bg--white" :theme="'blue'" :shadow="true" >
        <div class="card-container">
            <div class="row">
                <div class="col-12">
                    <big-title :text="'Actualités de l’app'" :theme="'blue'" :hasBlock="true"/>
                </div>

                <a class="col-lg-6 col-xs-12 simple-card" v-for="(actu, index) in news" :key="index" :href="'/actualite/' + actu.node.slug">
                    <simple-title :text="actu.node.title"></simple-title>
                    <v-sub-title :text="actu.node.subtitle"/>
                    <paragraph :text="actu.node.chapo"></paragraph>
                    <block-infos :infos="[{label: 'Pathologie', data: actu.node.pathology ? actu.node.pathology.name : ''},{label: 'Posté le', data: actu.node.publicationDate, date: true}, {label: 'par', data: actu.node.updatedBy}]"/>
                    <link-arrow-left :theme="'blue'" :text="'Voir le détail de l’actualité'" :href="'/actualite/' + actu.node.slug"  class="u-color--blue"/>
                </a>
            </div>
        </div>
        <div class="col-12 d-flex justify-content-center button">
            <flat-button :text="'Voir toutes les mises à jour et actualités'" class="u-bg--blue" :href="'/actualites'"/>
        </div>
    </card>
</template>

<script>
import Card from './../Granular/Card'
import BigTitle from '../../Core/BigTitle'
import SimpleTitle from '../../Core/SimpleTitle'
import Paragraph from './../../Core/Paragraph'
import FlatButton from './../../Core/FlatButton'
import VSubTitle from "../../Core/SubTitle";
import BlockInfos from './../Granular/BlockInfos'
import LinkArrowLeft from "../../Core/Link/LinkArrowLeft";

export default {
  name: 'card-multiple-actu',
  data: () => {
      return {
          date: ''
      }
  },
  props: ['news'],
  components: {
      LinkArrowLeft,
      VSubTitle,
      Card,
      BigTitle,
      SimpleTitle,
      Paragraph,
      FlatButton,
      BlockInfos
  },

}
</script>

<style lang="scss">
    .card-multiple-actu {
        position: relative;

        .card-container {
            padding: rem(50px) rem(30px) 0 rem(30px);
            width: 100%;
            height:100%;

            @include mq($until: MD) {
                padding: rem(20px) rem(15px) 0;

                div.simple-card:last-child {
                    position: relative;
                    padding-top: rem(30px);

                    &::before {
                        position: absolute;
                        content: '';
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 1px;
                        background-color: color(border);
                    }
                }
            }
        }

        .button {
            padding: 0;
            min-height: rem(50px);
            max-height: rem(50px);
            bottom: 0;
            right: 0;
            left: 0;

            .cta-flat:hover, &:focus {
                background-color: rgba(0,130,163,0.7);
            }
        }
    }

</style>
